import { render, staticRenderFns } from "./SalesRankingChart.vue?vue&type=template&id=38673ae2"
import script from "./SalesRankingChart.vue?vue&type=script&lang=js"
export * from "./SalesRankingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports